const { useI18n } = require('@fegobull/webapi').use;
import { ELang } from '@ark/utils';
const $t = useI18n({
  [ELang.KV.CN]: {
    // 里程碑组件
    Milestone: {
      optionCashCoupon: '大礼包',
      days: '{n}天',
    },
    // 主页面
    CheckinProgress: {
      // 主标题
      titlePrefix: '连续浏览赢',
      titleHighlight: '大礼包',
      // 副标题：再连续浏览X天可得 USD 10 / 500円
      subtitleTemplate: '再连续浏览{days}天可得{rewardWithCurrency}',
      subtitleNoRewardTemplate: '再浏览{days}天可得{rewardName}',
      // 完成所有里程碑
      allCompletedTemplate: '挑战成功，总计获得{totalRewardWithCurrency}！',
      allCompletedTemplateNoReward: '挑战成功，你已获得所有奖励！',
    },
    // 统计组件
    ProgressStats: {
      todayViewed: '今日浏览（篇）',
      totalRead: '累计浏览（篇）',
      totalBrowsed: '累计时长',
      secondUnit: '秒',
      minuteUnit: '分',
    },
  },
  [ELang.KV.EN]: {
    // 里程碑组件
    Milestone: {
      optionCashCoupon: 'Gift\nPackage',
      days: '{n}days',
    },
    // 主页面
    CheckinProgress: {
      // 主标题
      titlePrefix: 'Browse consecutively to win Gift Packages.',
      titleHighlight: '',
      // 副标题
      subtitleTemplate:
        'Browse for {days} more consecutive days to get {rewardWithCurrency}!',
      subtitleNoRewardTemplate:
        'Browse for {days} more consecutive days to get {rewardName}!',
      // 完成所有里程碑
      allCompletedTemplate:
        "Congrats! You've completed the max challenge and earned\n{totalRewardWithCurrency} in Gift Packages!",
      allCompletedTemplateNoReward:
        "Congrats! You've completed the max challenge and earned all rewards!",
    },
    // 统计组件
    ProgressStats: {
      todayViewed: 'Viewed Today',
      totalRead: 'Posts Viewed',
      totalBrowsed: 'Cumulative Time',
      secondUnit: 's',
      minuteUnit: 'm',
    },
  },
});

export default $t;
